module.exports = __webpack_public_path__ + "img/universkin-o-icon.48fd5cd2.svg";